import React from 'react';
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll';

type RevealDirection = 'up' | 'left' | 'right';
type RevealDelay = 0 | 1 | 2 | 3;

interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: RevealDelay;
  direction?: RevealDirection;
}

const directionClass: Record<RevealDirection, string> = {
  up: 'reveal-up',
  left: 'reveal-left',
  right: 'reveal-right',
};

const Reveal: React.FC<RevealProps> = ({
  children,
  className = '',
  delay = 0,
  direction = 'up',
}) => {
  const { ref, visible } = useRevealOnScroll<HTMLDivElement>();
  const delayClass = delay ? `reveal-up-delay-${delay}` : '';
  const visibleClass =
    direction === 'up'
      ? visible
        ? 'reveal-up--visible'
        : ''
      : visible
        ? 'reveal-axis--visible'
        : '';

  return (
    <div
      ref={ref}
      className={`${directionClass[direction]} ${delayClass} ${visibleClass} ${className}`.trim()}
    >
      {children}
    </div>
  );
};

export default Reveal;
